// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1noyad40 {
  width: 325px;
}
._1noyad41 {
  width: 100%;
}
@media screen and (min-width: 768px) {
  ._1noyad40 {
    width: initial;
  }
  ._1noyad41 {
    min-width: 180px;
    width: initial;
  }
  ._1noyad42 {
    min-height: 94px;
  }
  ._1noyad43 {
    max-width: 180px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":["._1noyad40 {\n  width: 325px;\n}\n._1noyad41 {\n  width: 100%;\n}\n@media screen and (min-width: 768px) {\n  ._1noyad40 {\n    width: initial;\n  }\n  ._1noyad41 {\n    min-width: 180px;\n    width: initial;\n  }\n  ._1noyad42 {\n    min-height: 94px;\n  }\n  ._1noyad43 {\n    max-width: 180px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
